import React, {Component} from 'react';
import TweenMax from 'gsap/TweenMax';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faBars } from '@fortawesome/free-solid-svg-icons';
import { faGithub } from '@fortawesome/free-brands-svg-icons';
import { faLinkedin } from '@fortawesome/free-brands-svg-icons';
import { StyleSheet, css } from 'aphrodite';

class TopMenu extends Component {
  state = {
    marginTop: -10,
    collapsed: true,
    extraText: <FontAwesomeIcon icon={faBars} />
  }

  expandMenu = () => {
    const objState = this.state;
    if(this.state.collapsed) {
      TweenMax.to(objState, 0.40, {marginTop: 0, onUpdate: () => {
        this.setState({marginTop: objState.marginTop, collapsed: false, extraText: ''})
      }})
    }
  }

  collapseMenu = () => {
    const objState = this.state;
    if(!this.state.collapsed) {
      TweenMax.to(objState, 0.40, {marginTop: -10, onUpdate: () => {
        this.setState({marginTop: objState.marginTop, collapsed: true, extraText: <FontAwesomeIcon icon={faBars} />})
      }})
    }
  }

  render() {
    const tMStyle = {
      
      zIndex: 4,
      width: '100vw',
      height: '13vh',
      //background: 'white',
      marginTop: this.state.marginTop + 'vh'
    }
    const menuStyle = {
      height: '10vh',
      width: '100vw',
      background: '#2b2b2f',
      borderBottom: 'solid black 1px'
    }
    const menuExtra = {
      height: '3vh',
      width: '100vw',
      color: '#f5b779',
      fontSize: '2.5em',
      paddingTop: '1vh',
      paddingRight: '2vw'
    }
    return (
      <div className="position-absolute" style={tMStyle} onMouseLeave={this.collapseMenu}>
        <div className={`row col-12 justify-content-around ${css(styles.tbMessageDiv)}`} style={menuStyle}>
          <p className={`${css(styles.tbMessage, styles.thanks)}`}>Thanks for taking the time to look at my portfolio. </p>
          <p className={`${css(styles.tbMessage)}`}><span className={css(styles.lText)}>Please take a look at my </span><a href="https://github.com/Momojunzi" target="blank" className={css(styles.medLink)}><FontAwesomeIcon icon={faGithub} /></a></p>
          <p className={`${css(styles.tbMessage)}`}><span className={css(styles.lText)}>And also my </span><a href="https://www.linkedin.com/in/mark-holthaus" target="blank" className={css(styles.medLink)}><FontAwesomeIcon icon={faLinkedin} /></a></p>
        </div>
        <div className="text-right" style={menuExtra} onClick={this.expandMenu}>{this.state.extraText}{this.state.extraTest}</div>
      </div>
    )
  }
}

const styles = StyleSheet.create({
  tbMessageDiv: {
    color: '#f5b779',
    height: '10vh'
  },
  tbMessage: {
    marginTop: '3vh',
    marginLeft: '2vw',
    fontSize: '1.5em'
  },
  thanks: {
    '@media (max-width: 1104px)': {
      display: 'none'
    }
  },
  lText: {
    '@media (max-width: 533px)': {
      display: 'none'
    }
  },
  medLink: {
    marginLeft: '1vw',
    '@media (max-width: 533px)': {
      marginleft: '25vw'
    }
  }
  
})

export default TopMenu;



// WEBPACK FOOTER //
// ./src/components/topMenu/topMenu.js